import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export async function gerarRelatorioPDF() {
    const target = document.getElementById("relatorio-pdf");
    const activeRestaurant = JSON.parse(localStorage.getItem("activeRestaurant"));


    // Pegar nome do restaurante (tratando espaços e acentos)
    const nomeRestaurante = (activeRestaurant?.nome || "restaurante")
        .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // remove acentos
        .replace(/[^a-zA-Z0-9]/g, "_")                    // troca espaços por _
        .toLowerCase();

    // Criar timestamp
    const agora = new Date();
    const yyyy = agora.getFullYear();
    const mm = String(agora.getMonth() + 1).padStart(2, "0");
    const dd = String(agora.getDate()).padStart(2, "0");
    const hh = String(agora.getHours()).padStart(2, "0");
    const min = String(agora.getMinutes()).padStart(2, "0");

    const nomePDF = `relatorio_mesaclick_${nomeRestaurante}_${dd}-${mm}-${yyyy}_${hh}-${min}.pdf`;


    if (!target) {
        console.error("Elemento relatorio-pdf não encontrado.");
        return;
    }

    // Captura em alta qualidade
    const canvas = await html2canvas(target, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
        removeContainer: false
    });

    const pdf = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: "a4",
        compress: true
    });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const margin = 15; // mm
    const imgWidth = pageWidth - margin * 2;
    const usableHeight = pageHeight - margin * 2; // área útil por página (com margem em cima e embaixo)

    // Pixels por mm (baseado na escala do canvas)
    const pxPerMm = canvas.width / imgWidth;
    const usableHeightPx = usableHeight * pxPerMm;

    let yOffset = 0;
    let firstPage = true;

    while (yOffset < canvas.height) {
        const remaining = canvas.height - yOffset;
        if (remaining < usableHeightPx * 0.05) break; // evita página em branco por resíduo de padding/margem

        if (!firstPage) pdf.addPage();
        firstPage = false;

        // Fatia exata da página atual
        const sliceHeightPx = Math.min(usableHeightPx, remaining);
        const sliceCanvas = document.createElement("canvas");
        sliceCanvas.width = canvas.width;
        sliceCanvas.height = sliceHeightPx;

        const ctx = sliceCanvas.getContext("2d");
        ctx.drawImage(canvas, 0, yOffset, canvas.width, sliceHeightPx, 0, 0, canvas.width, sliceHeightPx);

        const sliceImg = sliceCanvas.toDataURL("image/jpeg", 0.85);
        const sliceHeightMm = sliceHeightPx / pxPerMm;

        pdf.addImage(sliceImg, "JPEG", margin, margin, imgWidth, sliceHeightMm);

        yOffset += usableHeightPx;
    }


    pdf.save(nomePDF);
}
